export enum DownloadFileType {
  PDF = 'pdf',
  Excel = 'xlsx',
}
